export interface Dictionary {
  [className: string]: boolean;
}

export type CssInput = string | Dictionary | null | undefined | boolean;

export function css(...args: CssInput[]): string {
  const classes: string[] = [];

  for (const arg of args) {
    if (arg) {
      if (typeof arg === 'string') {
        classes.push(arg);
      } else {
        for (const key in arg as any) {
          if ((arg as any)[key]) {
            classes.push(key);
          }
        }
      }
    }
  }

  return classes.join(' ');
}
